import React from 'react'

const AgentChatLogo = () => {
  return (
    <React.Fragment>
      <svg
        version='1.0'
        xmlns='http://www.w3.org/2000/svg'
        width='60'
        height='60'
        viewBox='0 0 121.000000 92.000000'
        preserveAspectRatio='xMidYMid meet'
        fill='currentColor'
      >
        <g transform='translate(0.000000,92.000000) scale(0.100000,-0.100000)'>
          <path
            d='M563 761 c-49 -23 -92 -69 -113 -121 -8 -21 -27 -48 -42 -60 -25 -19
            -28 -28 -28 -80 0 -40 5 -61 16 -71 12 -10 15 -31 13 -100 -3 -98 6 -119 52
            -119 26 0 29 -3 29 -35 0 -23 5 -35 14 -35 8 0 33 16 56 35 l42 35 124 0 c146
            0 144 -1 144 113 0 61 3 77 20 92 16 15 20 31 20 90 0 66 -2 73 -24 83 -13 6
            -27 23 -30 39 -29 117 -178 186 -293 134z m175 -30 c46 -23 67 -46 87 -94 13
            -32 13 -37 0 -37 -8 0 -19 9 -25 20 -19 35 -63 50 -150 50 -87 0 -131 -15
            -150 -50 -6 -11 -17 -20 -25 -20 -13 0 -13 5 0 37 32 75 89 112 173 113 32 0
            67 -7 90 -19z m29 -113 c21 -19 23 -30 23 -114 0 -132 -7 -139 -140 -139 -133
            0 -140 7 -140 138 0 79 3 94 22 114 20 21 30 23 117 23 83 0 97 -3 118 -22z
            m-279 -116 c3 -82 -9 -97 -53 -68 -21 14 -25 24 -25 66 0 54 19 83 54 78 19
            -3 21 -10 24 -76z m386 62 c22 -21 21 -107 0 -129 -9 -9 -26 -15 -38 -13 -19
            3 -21 11 -24 67 -2 35 -1 70 2 77 7 19 41 18 60 -2z m-357 -194 c25 -30 25
            -30 133 -30 108 0 108 0 133 30 14 17 35 30 46 30 24 0 25 -5 10 -48 -15 -44
            -52 -65 -98 -57 -27 4 -41 2 -50 -9 -10 -12 -9 -16 7 -25 23 -12 105 10 134
            36 17 15 18 15 18 -13 0 -49 -13 -54 -145 -54 -117 0 -122 -1 -145 -25 -13
            -14 -29 -25 -35 -25 -8 0 -10 10 -7 25 4 23 1 25 -30 25 -49 0 -58 14 -58 97
            l0 73 31 0 c21 0 38 -9 56 -30z'
          />
          <path
            d='M601 548 c-5 -13 -16 -40 -25 -62 -20 -48 -20 -56 -1 -56 8 0 15 7
            15 15 0 24 57 19 70 -5 24 -45 26 -6 2 60 -26 72 -46 88 -61 48z m33 -34 c10
            -26 7 -34 -15 -34 -15 0 -19 4 -15 16 3 9 6 20 6 25 0 15 17 10 24 -7z'
          />
          <path
            d='M704 503 c3 -45 9 -69 18 -71 10 -2 13 14 11 65 -1 53 -5 69 -17 71
            -14 3 -15 -6 -12 -65z'
          />
        </g>
      </svg>
    </React.Fragment>
  )
}

export default AgentChatLogo
